import React from "react"

function SvgComponent({ width = 30, height = 30, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox={`0 0 20 20`} {...props}>
      <title>{"Facebook"}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 10.0503C1 14.5248 4.24975 18.2455 8.5 19V12.4998H6.25V10H8.5V7.99975C8.5 5.74975 9.94975 4.50025 12.0002 4.50025C12.6497 4.50025 13.3503 4.6 13.9998 4.69975V7H12.85C11.7498 7 11.5 7.54975 11.5 8.25025V10H13.9L13.5002 12.4998H11.5V19C15.7502 18.2455 19 14.5255 19 10.0503C19 5.0725 14.95 1 10 1C5.05 1 1 5.0725 1 10.0503Z" /* eslint-disable-line */
        fill="currentColor"
      />
      ;
    </svg>
  )
}

export const FacebookRoundIcon = React.memo(SvgComponent)

FacebookRoundIcon.displayName = "FacebookRoundIcon"
